import React from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { OfferingCardLane } from '@ole-ui/ole-ui-components';
import useMobxStores from 'hooks/useMobxStores';
import { BaseOfferingCard } from 'components/OfferingCards';
import { CommonLaneProps } from './types';

const NEW_OFFERINGS_MAX_ITEMS = 10;

const NewOfferingsLane = ({ expanded, onTitleClick }: CommonLaneProps) => {
  const { t } = useTranslation();
  const { catalogStore } = useMobxStores();

  return (
    <OfferingCardLane
      className="new_lane"
      emptyMessage={
        <p className="empty-message">
          {t(
            'You have progress on all offerings that were published within the last 180 days. View the Catalog in order of newest published to see all offerings based on their publish date.',
          )}
        </p>
      }
      expanded={expanded}
      items={catalogStore.newOfferingsCatalogEntries}
      maxItems={NEW_OFFERINGS_MAX_ITEMS}
      onTitleClick={onTitleClick}
      renderItem={(entry) => <BaseOfferingCard entry={entry} />}
      title={t('New')}
    />
  );
};

export default observer(NewOfferingsLane);
